module.exports = __webpack_public_path__ + "img/photographProduct.4bd1cb59.jpg";